import { Member } from 'api/MembersAPI';
import { createContext, useContext } from 'react';

type MembersContextType = {
  getMemberByUserId: (userId: string) => Member | undefined;
  isLoadingMembers: boolean;
  members: Member[];
  membersByUserId: { [key: string]: Member };
  orgAdmins: string[];
  projectMemberships: { [key: string]: string[] };
  refetchMembers: () => void;
  teamMemberships: { [key: string]: string[] };
};

const defaultState = {
  getMemberByUserId: () => undefined,
  isLoadingMembers: false,
  members: [],
  membersByUserId: {},
  orgAdmins: [],
  projectMemberships: {},
  refetchMembers: () => undefined,
  teamMemberships: {},
};

export const MembersContext = createContext<MembersContextType>(defaultState);

export const useMembersContext = () => useContext<MembersContextType>(MembersContext);
